import { useField } from "formik"
import { InputNumber } from "primereact/inputnumber"
import { useEffect } from "react"

const FormikInputNumber = ({
  id,
  min,
  max,
  mode,
  disabled,
  currency,
  minFractionDigits,
  maxFractionDigits,
  onChange,
  useGrouping = false,
  className = "",
  suffix,
  preffix,
  placeholder,
  readOnly,
  isActiveErrorMsg = true,
  ...props
}: $TSMigrationFixMe) => {
  const [field, meta, helpers] = useField(props)

  useEffect(() => {
    const el = document.querySelector(`input[name="${props.name}"]`)
    el?.setAttribute("autocomplete", "off")
  }, [props.name])

  const errorMsg = meta.error && meta.touched ? meta.error : ""

  return (
    <>
      <InputNumber
        id={id}
        disabled={disabled}
        min={min}
        max={max}
        mode={mode}
        currency={currency}
        useGrouping={useGrouping}
        minFractionDigits={minFractionDigits}
        maxFractionDigits={maxFractionDigits}
        suffix={suffix}
        // @ts-expect-error TS(2769): No overload matches this call.
        preffix={preffix}
        placeholder={placeholder}
        {...field}
        readOnly={readOnly}
        onChange={onChange || ((e) => helpers.setValue(e.value))}
        className={`${className} ${errorMsg ? "p-invalid" : ""}`}
        style={{ ...(readOnly && { pointerEvents: "none" }) }}
      />
      {errorMsg && isActiveErrorMsg && (
        <small className='p-error p-d-block'>{errorMsg}</small>
      )}
    </>
  )
}

export default FormikInputNumber
